import qs from 'qs';

export default class QueryStringHelper {
  static objectToQuery(object: unknown): string {
    const queryString = qs.stringify(object, { encodeValuesOnly: true });
    return `?${queryString}`;
  }

  static getValueByKey(field: string): string | null {
    return new URLSearchParams(window.location.search).get(field);
  }
}
